import { IListItem } from "shared/models/common";
import { DatesFormat } from "shared-types";
import { addHours, format } from "date-fns";
import { utcToZonedTime, format as formatTZ } from "date-fns-tz";
import { dateFormats } from "services/dateService";
import {
  UTC,
  UK_SUMMERTIME_OFFSET,
  OFFSET_FORMAT,
  UK_TIME_ZONE,
} from "components/SelfTapeRequestInfo/constants";

export class ListItemTranslator {
  constructor(
    private loadedData: IListItem[],
    private fallbackData: IListItem[]
  ) {}

  public get(key: string): string {
    return ((this.loadedData || this.fallbackData).find(
      (item) => item.TypeId === key
    )?.Translation ||
      this.fallbackData.find((item) => item.TypeId === key)
        ?.Translation) as string;
  }
}

export function prepareHelper(title: string, html: string) {
  return {
    title,
    html,
  };
}

export function isUKSummerTime(date: string | Date): boolean {
  const timeZone = UK_TIME_ZONE;
  const ukDate = utcToZonedTime(date, timeZone);
  // BST is +01:00, GMT is +00:00
  const offset = formatTZ(ukDate, OFFSET_FORMAT, { timeZone });

  return offset === UK_SUMMERTIME_OFFSET;
}

export function getTranslationDateAndTimeFromTagmin({
  isTagminUser,
  dateFormat,
  timeFormat,
  date,
}: {
  isTagminUser: boolean;
  dateFormat: DatesFormat;
  timeFormat: DatesFormat;
  date: string;
}) {
  const localDate = utcToZonedTime(date, UTC);
  const localDateString = formatTZ(localDate, dateFormats.isoLocalDateTime, {
    timeZone: UTC,
  });

  let responseTime = new Date(localDateString);

  if (isTagminUser && isUKSummerTime(date)) {
    responseTime = addHours(responseTime, 1);
  }

  return {
    date: format(responseTime, dateFormat),
    time: format(responseTime, timeFormat),
  };
}

export function getTranslationDateAndTime({
  dateFormat,
  timeFormat,
  date,
}: {
  dateFormat: DatesFormat;
  timeFormat: DatesFormat;
  date?: string;
}) {
  const responseTime = date ? new Date(date) : new Date();

  return {
    date: format(responseTime, dateFormat),
    time: format(responseTime, timeFormat),
  };
}
